import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { cancelAllGlobalRequests } from '../utils/globalApiCancellationManager';

// Component that listens to route changes and cancels requests only on actual navigation
export default function RouteChangeCancellation() {
  const location = useLocation();
  const previousLocationRef = useRef(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;
    const previousPath = previousLocationRef.current;

    // Only cancel requests if we're actually navigating to a different page
    if (previousPath !== currentPath) {
      console.log(`🚫 Route changed from ${previousPath} to ${currentPath} - Cancelling all active requests`);
      cancelAllGlobalRequests(`Route changed from ${previousPath} to ${currentPath}`);
      previousLocationRef.current = currentPath;
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
}
